import React from 'react'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { scheduleStatusVariant } from '@/lib/status-variants'
import type { ScheduleStatus } from '../lib/constants'

const ScheduleStatusBadge: React.FC<{ status: ScheduleStatus; className?: string }> = ({ status, className }) => {
  const { t } = useTranslation()
  return <Badge variant={scheduleStatusVariant(status)} className={className}>{t(`Schedule_status_${status}`)}</Badge>
}
export default ScheduleStatusBadge
